import React from 'react';
import { Button } from 'antd';
import { SunOutlined, MoonOutlined } from '@ant-design/icons';
import { useTheme } from '../../../hooks/useTheme';

/**
 * Componente para alternar entre tema light e dark.
 * 
 * Exibe um botão com ícone de sol (light) ou lua (dark)
 * que permite alternar entre os temas.
 */
export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      type="text"
      icon={theme === 'light' ? <MoonOutlined /> : <SunOutlined />}
      onClick={toggleTheme}
      title={theme === 'light' ? 'Alternar para modo escuro' : 'Alternar para modo claro'}
    >
      {theme === 'light' ? 'Escuro' : 'Claro'}
    </Button>
  );
};

export default ThemeToggle;

